import React, { useRef } from "react";
import { useTrackInViewport } from "src/hooks/viewport";
import { Text } from "src/components/core/Text";
import {
  Box,
  BoxSection,
  Content,
  Icon,
  Section,
  CTASection,
  Title,
} from "./BelowFold.styles";

import iconCalendar from "./images/calendar.png";
import iconPan from "./images/pan.png";
import iconStar from "./images/star.png";

const EVENT_CTA_IN_VIEW = "ScrolledLandingPageBottomCTA";

export const BelowFold = ({ children }) => {
  const buttonRef = useRef(null);
  useTrackInViewport(buttonRef, EVENT_CTA_IN_VIEW);

  return (
    <Box>
      <BoxSection>
        <Section>
          <Icon src={iconStar} />
          <Title>
            <Text i18nKey="belowFold:benefits:title1" />
          </Title>
          <Content>
            <Text i18nKey="belowFold:benefits:content1" />
          </Content>
        </Section>
        <Section>
          <Icon src={iconPan} />
          <Title>
            <Text i18nKey="belowFold:benefits:title2" />
          </Title>
          <Content>
            <Text i18nKey="belowFold:benefits:content2" />
          </Content>
        </Section>
        <Section>
          <Icon src={iconCalendar} />
          <Title>
            <Text i18nKey="belowFold:benefits:title3" />
          </Title>
          <Content>
            <Text i18nKey="belowFold:benefits:content3" />
          </Content>
        </Section>
      </BoxSection>
      <CTASection ref={buttonRef}>{children}</CTASection>
    </Box>
  );
};
